/*
 * Mr Good Luck confetti — tiny self-contained canvas burst for winner reveals.
 * No dependencies; colors are read from the brand tokens (--color-*) at burst
 * time so the palette stays single-sourced. Bails under reduced motion, the
 * theme editor, and missing canvas support.
 *
 *   window.cukConfetti.burst({ x, y, count })  — manual burst (viewport px).
 *   [data-cuk-confetti]                        — auto burst (once per element)
 *                                                when it first becomes visible.
 */
(function () {
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;
  var dead = reduce || inEditor || !window.requestAnimationFrame || !d.createElement('canvas').getContext;

  var canvas = null;
  var ctx = null;
  var parts = [];
  var raf = 0;

  function tokenColors() {
    var cs = getComputedStyle(d.documentElement);
    var names = ['--color-brand', '--color-prize', '--color-accent', '--color-brand-light'];
    var out = [];
    for (var i = 0; i < names.length; i++) {
      var v = cs.getPropertyValue(names[i]).trim();
      if (v) out.push(v);
    }
    // Fallback mirrors --color-brand (clover green) for the no-computed-style case.
    return out.length ? out : ['#0c8449'];
  }

  function ensureCanvas() {
    if (canvas) return;
    canvas = d.createElement('canvas');
    canvas.className = 'cuk-confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    d.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    size();
    window.addEventListener('resize', size, { passive: true });
  }

  function size() {
    if (!canvas) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function teardown() {
    raf = 0;
    if (!canvas) return;
    window.removeEventListener('resize', size);
    canvas.remove();
    canvas = null;
    ctx = null;
  }

  function loop() {
    if (!ctx) return;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    var alive = [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      p.vy += 0.12; // gravity
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;
      p.life -= 1;
      if (p.life <= 0 || p.y > window.innerHeight + 24) continue;
      alive.push(p);
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = Math.min(1, p.life / 30);
      ctx.fillStyle = p.color;
      if (p.circle) {
        ctx.beginPath();
        ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }
      ctx.restore();
    }
    parts = alive;
    if (parts.length) raf = window.requestAnimationFrame(loop);
    else teardown();
  }

  function burst(opts) {
    if (dead) return;
    opts = opts || {};
    ensureCanvas();
    var x = typeof opts.x === 'number' ? opts.x : window.innerWidth / 2;
    var y = typeof opts.y === 'number' ? opts.y : window.innerHeight * 0.3;
    var count = opts.count || 90;
    var colors = tokenColors();
    for (var i = 0; i < count; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 2 + Math.random() * 7;
      parts.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 5,
        vr: (Math.random() - 0.5) * 0.3,
        rot: Math.random() * Math.PI,
        w: 5 + Math.random() * 6,
        h: 3 + Math.random() * 5,
        circle: Math.random() < 0.3,
        life: 110 + Math.random() * 60,
        color: colors[i % colors.length],
      });
    }
    if (!raf) raf = window.requestAnimationFrame(loop);
  }

  window.cukConfetti = { burst: burst };

  // Auto mode: fire once per [data-cuk-confetti] element when it becomes
  // visible (covers banners un-hidden by other scripts — IO fires on
  // visibility changes, not just scroll).
  if (dead || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.isIntersecting) continue;
      io.unobserve(e.target);
      var r = e.target.getBoundingClientRect();
      burst({ x: r.left + r.width / 2, y: Math.max(40, r.top), count: 110 });
    }
  }, { threshold: 0.5 });

  function scan() {
    var els = d.querySelectorAll('[data-cuk-confetti]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__cukConfetti) continue;
      el.__cukConfetti = true;
      io.observe(el);
    }
  }

  function start() {
    scan();
    if ('MutationObserver' in window) {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          scan();
        });
      });
      mo.observe(d.body, { childList: true, subtree: true });
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
